import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const filescan = defineConnector({
  identifier: "filescan",
  name: "FileScan",
  tagLine: "Malware analysis",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://www\\.filescan\\.io/.*",
  auth: (app) => headerAuth([{ name: "X-Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [FileScan](https://www.filescan.io/), go to your account settings to find your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://www.filescan.io/api/system/do-healthcheck",
  },
});
